import {
  Component,
  inject,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SidebarModule } from 'primeng/sidebar';

import { Product } from '../cart.model';
import { ProductListComponent } from '../product-list/product-list.component';
import { CartService } from '../cart.service';
import { QuantityCounterComponent } from '../quantity-counter/quantity-counter.component';
import { FormsModule } from '@angular/forms';
import { BadgeModule } from 'primeng/badge';
import { Subscription } from 'rxjs/internal/Subscription';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { IngredientNamePipe } from 'src/app/pipes/ingredient-name/ingredient-name.pipe';
import { RouterLink } from '@angular/router';
import _ from 'lodash';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    NgFor,
    NgIf,
    ProductListComponent,
    QuantityCounterComponent,
    InputTextareaModule,
    FormsModule,
    SidebarModule,
    BadgeModule,
    TooltipModule,
    IngredientNamePipe,
    RouterLink,
  ],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
})
// implements OnInit
export class CartComponent {
  cartService = inject(CartService);
  sidebarVisible: boolean = false;
  totalElements: number = 0;
  subtotal: number = 0;
  subscription: Subscription;
  subscriptionSubtotal: Subscription;

  @ViewChild(Tooltip) tooltip!: Tooltip;
  @ViewChildren(Tooltip) tooltips!: QueryList<Tooltip>;

  // cart: CartProduct[] = [];
  cartWrapper!: HTMLElement;
  cartEmptyBtn!: HTMLElement;
  // productList!: HTMLElement;
  productAddBtn!: HTMLElement;
  productList!: Product[];
  lodash;

  // BASE_URL = `http://localhost:3605`;
  BASE_URL = environment.api_redsys;

  constructor() {
    this.productList = this.cartService.productList;
    this.totalElements = this.cartService.setTotalElements();
    this.subtotal = this.cartService.calculateSubtotalAmount();
    this.subscription = this.cartService.totalElements$.subscribe(
      (data: number) => {
        this.totalElements = data;
      }
    );

    this.subscriptionSubtotal = this.cartService.subtotal$.subscribe(
      (data: number) => {
        this.subtotal = data;
      }
    );

    this.lodash = _;
  }

  changeQuantity(index: number, value: number | null) {
    if (value !== null) {
      this.cartService.changeProductQuantity(index, value);
    }
  }

  removeProduct(index: number) {
    this.cartService.removeProduct(index);
  }

  emptyCart() {
    this.cartService.emptyCart();
    this.totalElements = 0;
  }

  private findTooltipById(searchId: string): Tooltip | undefined {
    return this.tooltips.find(
      tooltip => tooltip.el.nativeElement.id === searchId
    );
  }

  clickTooltip(index: number) {
    const tooltip = this.findTooltipById(`show-${index}`);
    if (tooltip) {
      this.tooltips.forEach(element => {
        element.deactivate();
      });
      tooltip.active ? tooltip.deactivate() : tooltip.activate();
    }
  }

  tpvControl = {
    generarDatosPeticion: async () => {
      // const concept = document.getElementById('producto_concept')?.innerHTML;
      // const amount = document.getElementById('producto_amount')?.innerHTML;
      const concept = 'Prueba';
      const amount = this.subtotal;

      const fetch_url = `${this.BASE_URL}/api/redsys`;

      const formDataObject = { concept, amount };

      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const options: any = {
        method: 'POST',
        mode: 'cors',
        headers: myHeaders,
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(formDataObject),
      };

      const generarDatosOperacion = await fetch(fetch_url, options).then(res =>
        res.json()
      );

      return generarDatosOperacion;
    },
    // crearInputHidden: (nombre: any, valor: any) => {
    //   const input = document.createElement('input');
    //   input.id = nombre;
    //   input.name = nombre;
    //   input.type = 'hidden';
    //   input.value = valor;
    //   document.forms[0].append(input);
    // },
  };

  Ds_SignatureVersion = '';
  Ds_MerchantParameters = '';
  Ds_Signature = '';

  async tpv() {
    // const btn_enviar = document.getElementsByName('btn_submit');
    // btn_enviar[0].addEventListener('click', async (e) => {
    // e.preventDefault();

    // });
    // const call = async () => {
    const datosRecuperados = await this.tpvControl.generarDatosPeticion();
    // console.log('datosRecuperados', datosRecuperados);

    // Añadimos campos necesarios para sistema SHA-256
    // this.tpvControl.crearInputHidden(
    //   'Ds_SignatureVersion',
    //   datosRecuperados.version
    // );
    this.Ds_SignatureVersion = datosRecuperados.version;
    // this.tpvControl.crearInputHidden(
    //   'Ds_MerchantParameters',
    //   datosRecuperados.params
    // );

    this.Ds_MerchantParameters = datosRecuperados.params;

    // this.tpvControl.crearInputHidden(
    //   'Ds_Signature',
    //   datosRecuperados.signature
    // );

    this.Ds_Signature = datosRecuperados.signature;
    const Ds_Signature: HTMLInputElement | null = document.querySelector(
      "[name='Ds_Signature']"
    );

    Ds_Signature!.value = datosRecuperados.Ds_Signature;
    // ?.setAttribute('value', datosRecuperados.Ds_Signature);

    // document
    //   .querySelector("[name='Ds_Signature']")
    //   ?.setAttribute('value', datosRecuperados.Ds_Signature);
    document
      .querySelector("[name='Ds_SignatureVersion']")
      ?.setAttribute('value', datosRecuperados.Ds_SignatureVersion);
    document
      .querySelector("[name='Ds_MerchantParameters']")
      ?.setAttribute('value', datosRecuperados.Ds_MerchantParameters);
    // document
    //   .querySelector("[name='Ds_Merchant_MerchantCode']")
    //   ?.setAttribute('value', datosRecuperados.Ds_MerchantParameters);

    document.forms[0].setAttribute('action', datosRecuperados.URL_TPV);
    document.forms[0].submit();
    return;
    // };

    // call();
  }
}
